module.exports = __webpack_public_path__ + "img/service3-03.a53101e4.png";